import { format } from 'date-fns';

/**
 * E.g. "Jan 1 • 10:00 AM - 11:00 AM"
 */
export function formatRange(startTime: Date, endTime: Date) {
  if (startTime > endTime) {
    return null;
  }

  const formattedStartTime = format(startTime, 'h:mm a');
  const formattedEndTime = format(endTime, 'h:mm a');
  const monthAndDay = format(startTime, 'MMM d');

  return `${monthAndDay} • ${formattedStartTime} - ${formattedEndTime}`;
}
